<template>
  <PageLayout>
    <template #main>
      <h2 class="text-h3 font-weight-bold navy--text text--darken-1 pb-10">
        Vytvořte si nový účet
      </h2>

      <v-form class="pb-6">
        <v-text-field
          v-model="firstName"
          :error-messages="getValidationsErrors('firstName')"
          label="Jméno"
          outlined
          name="firstName"
          type="text"
          @input="isValid('firstName')"
        />

        <v-text-field
          v-model="lastName"
          :error-messages="getValidationsErrors('lastName')"
          label="Příjmení"
          outlined
          name="lastName"
          type="text"
          @input="isValid('lastName')"
        />

        <v-text-field
          v-model="username"
          :error-messages="getValidationsErrors('username')"
          label="E-mail"
          outlined
          name="username"
          type="email"
          @input="isValid('username')"
        />

        <v-text-field
          v-model="password"
          :error-messages="getValidationsErrors('password')"
          label="Heslo"
          :type="showPassword ? 'text' : 'password'"
          outlined
          name="password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @input="isValid('password')"
          @click:append="showPassword = !showPassword"
        />

        <v-text-field
          v-model="passwordRetype"
          :error-messages="getValidationsErrors('passwordRetype')"
          label="Heslo znovu pro kontrolu"
          :type="showPasswordRetype ? 'text' : 'password'"
          outlined
          name="passwordRetype"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @input="isValid('passwordRetype')"
          @click:append="showPasswordRetype = !showPasswordRetype"
        />

        <v-checkbox
          v-model="agreeWithTerms"
          :error-messages="getValidationsErrors('agreeWithTerms')"
          label="Souhlasím s Obchodními podmínkami a Zásadami ochrany osobních údajů"
        />

        <v-alert
          v-if="apiResponseState.status === 201"
          type="success"
          outlined
          text
          class="mb-4"
        >
          <div>
            Registrace proběhla úspěšně. Před přihlášením je třeba ještě ověřit
            Váš email, zkontrolujte prosím svoji emailovou schránku.
          </div>
        </v-alert>

        <v-alert
          v-if="apiResponseState.status > 201"
          type="error"
          outlined
          text
          class="mb-4"
        >
          <div v-if="apiResponseState.status === 409">
            Uživatel s tímto e-mailem už existuje. Chcete se spíše
            <router-link to="/login" class="link link-underline"
              >přihlásit</router-link
            >?
          </div>
          <div v-else>
            Něco se pokazilo
          </div>
        </v-alert>
      </v-form>

      <div class="text-center pb-10">
        <v-btn
          type="submit"
          color="primary"
          class="c-btn"
          :loading="appRegistrationPending"
          @click="onRegisterClick"
        >
          Registrovat se
        </v-btn>
      </div>

      <div class="text-center">
        <span class="navy--text">Již mám účet.</span>
        <router-link to="login" class="link link-underline navy--text ml-2">
          Přihlásit se
        </router-link>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import { call, get, sync } from "vuex-pathify"
import { email, minLength, required, sameAs } from "vuelidate/lib/validators"
import validation from "@/mixins/validation"

import PageLayout from "@/components/page/auth/PageLayout.vue"

export default {
  name: "Registration",
  components: {
    PageLayout,
  },
  mixins: [validation],
  data() {
    return {
      validationMessages: {
        firstName: {
          required: "Jméno musí být zadáno",
        },
        lastName: {
          required: "Příjmení musí být zadáno",
        },
        username: {
          required: "Email musí být zadán",
          email: "Špatný tvar e-mailu",
        },
        password: {
          required: "Heslo musí být zadáno",
          minLength: "Heslo musí být dlouhé alespoň 4 znaky",
        },
        passwordRetype: {
          required: "Zadejte heslo ještě jednou pro kontrolu",
          sameAsPassword:
            "Opětovné zadání hesla se neshoduje se zadaným heslem",
        },
        agreeWithTerms: {
          sameAs: "Je vyžadován souhlas",
        },
      },
      showPassword: false,
      showPasswordRetype: false,
    }
  },
  validations: {
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    username: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(4),
    },
    passwordRetype: {
      required,
      sameAsPassword: sameAs("password"),
    },
    agreeWithTerms: {
      sameAs: sameAs(() => true),
    },
  },
  computed: {
    ...get("app", ["apiResponseState"]),
    ...get("auth", ["appRegistrationPending"]),
    ...sync("auth/registrationModel@", [
      "firstName",
      "lastName",
      "username",
      "password",
      "passwordRetype",
      "agreeWithTerms",
    ]),
  },
  methods: {
    ...call("app", ["resetApiResponseState"]),
    ...call("auth", ["register"]),
    onRegisterClick() {
      if (this.isValid()) {
        this.register().then(() => {
          this.validationReset()
        })
      }
    },
  },
  mounted() {
    this.resetApiResponseState()
  },
}
</script>

<style scoped></style>
